export const databaseName = 'plugin_business';

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const extensionToLanguage: { [key: string]: string } = {
  'java': 'Java',
  'kt': 'Kotlin',
  'groovy': 'Groovy',
  'js': 'JavaScript',
  'ts': 'TypeScript',
  'yaml': 'YAML',
  'yml': 'YAML',
  'json': 'JSON',
  'xml': 'XML',
  'html': 'HTML',
  'css': 'CSS',
  'scss': 'Sass',
  'less': 'Less',
  'sql': 'SQL',
  'cfg': 'Configuration',
  'properties': 'Properties',
  'md': 'Markdown',
  'txt': 'Plain Text',
  'sh': 'Shell Script',
  'php': 'PHP',
  'rb': 'Ruby',
  'py': 'Python',
  'cs': 'C#',
  'c': 'C',
  'cpp': 'C++',
  'h': 'C/C++ Header',
  'lua': 'Lua',
  'pl': 'Perl',
  'swift': 'Swift',
  'go': 'Go',
}

export const supportedVersions = ['1.19', '1.20'];

// initial plugin code
export const defaultPluginCode = `import org.bukkit.plugin.java.JavaPlugin;

public class NewPlugin extends JavaPlugin {

  @Override
  public void onEnable() {
    System.out.println("NewPlugin enabled!");
  }

}
`;

// yml code
export const pluginYml =
`name: NewPlugin
version: 1.0
main: <USERNAME>.<RESOURCE_NAME>.NewPlugin
description: A description about the plugin.
author: Author
api-version: '1.20'`;

// buildspect for aws codebuild to execute
export const buildspecTemplate = {
  head: `version: 0.2\n\nphases:
  build:
    commands:
  `,
  // download files from s3 to codebuild
  filesCommands: `
      - aws s3 cp s3://${databaseName.replace('_', '-')}-bucket/spigot-api-1.20.jar ./spigot-api.jar
      - aws s3 cp s3://${databaseName.replace('_', '-')}-bucket/<USERNAME>/<RESOURCE_ID>/manifest.txt ./manifest.txt
  `,
  // build
  buildCommands: `
      - javac -d classes -cp ./spigot-api.jar *.java
      - cp plugin.yml classes/
      - jar cfm <PLUGIN_NAME>.jar manifest.txt -C classes .
      - rm -f manifest.txt
  `,
  // store jar file to s3
  storeCommands: `
      - aws s3 cp <PLUGIN_NAME>.jar s3://${databaseName.replace('_', '-')}-bucket/<USERNAME>/<RESOURCE_ID>/<RESOURCE_ID>.jar
  `,
};

